import { render, staticRenderFns } from "./batchAddFriend.vue?vue&type=template&id=e1ef0692&scoped=true"
import script from "./batchAddFriend.vue?vue&type=script&lang=js"
export * from "./batchAddFriend.vue?vue&type=script&lang=js"
import style0 from "./batchAddFriend.vue?vue&type=style&index=0&id=e1ef0692&prod&lang=less&scoped=true"
import style1 from "./batchAddFriend.vue?vue&type=style&index=1&id=e1ef0692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ef0692",
  null
  
)

export default component.exports